export const PROFILE_NO_DISPLAY_SEARCH_KEY = "profile_no_display";
export const PROFILE_NO_DISPLAY_SORT_KEY = "profile_no_display";
export const DISPLAY_PROFILE_NUMBER_FIELD = "profile_no_display";
export const RAW_PROFILE_NUMBER_FIELD = DISPLAY_PROFILE_NUMBER_FIELD;

export function getProfileNumberPrefix(gender) {
  const normalized = String(gender || "").trim().toLowerCase();
  if (normalized === "male") return "M";
  if (normalized === "female") return "F";
  return "";
}

export function formatProfileNumberValue(profileNo, gender, fallback = "") {
  const rawValue = String(profileNo ?? "").trim().replace(/^#/, "");
  if (!rawValue) return fallback;
  if (/^[mf]\d+$/i.test(rawValue)) return rawValue.toUpperCase();
  if (!/^\d+$/.test(rawValue)) return rawValue;
  const prefix = getProfileNumberPrefix(gender);
  return prefix ? `${prefix}${rawValue}` : rawValue;
}

export function getProfileNumberDisplay(profile, fallback = "") {
  if (!profile) return fallback;
  return formatProfileNumberValue(
    profile[DISPLAY_PROFILE_NUMBER_FIELD] || profile.profileNoDisplay || profile.profileNo,
    profile.gender,
    fallback
  );
}

export function formatProfileNumberBadge(profile, fallback = "—") {
  const value = getProfileNumberDisplay(profile, "");
  return value || fallback;
}

export function isProfileNoDisplaySearchMode(value) {
  return String(value || "").trim().toLowerCase() === PROFILE_NO_DISPLAY_SEARCH_KEY;
}
